import { constants } from "@newsela/angelou";

import { AssignModalZIndex } from "@/view/AssignModal/AssignModal.style";

const { ui } = constants.colors;

export const advisoryModalRootCss = {
  zIndex: AssignModalZIndex,
};

export const advisoryModalCss = {
  maxWidth: "800px !important",
  maxHeight: "375px !important",
};

export const advisoryModalFooterCss = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
};

export const catCheckboxCss = {
  background: ui.neutral[25],
  borderRadius: "7px",
  marginTop: "10px",

  "& > div:first-of-type": {
    paddingRight: "0px",
  },
};

export const catCheckboxLabelTextCss = {
  background: ui.neutral[25],
  color: ui.black[700],
  fontSize: "14px",
  bordeRadius: "7px",
  marginLeft: "12px",
};

export const advisoryModalBodyCss = {
  flexGrow: 1,
  maxHeight: "220px",
};
